// Vue
import { Vue, Component, Prop } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
  },
})
export class TeaserModule extends ModuleBase {
  getBackgroundColorFromInstance(instance: object): string {
    return this.instance["background"];
  }

  public buttonTheme(type) {
    switch (type) {
      case "wb-e-btn-1":
        return "primary";
      case "wb-e-btn-2":
        return "default";
      case "wb-e-btn-3":
        return "inverted";
      case "button_outline":
        return "outline-secondary";
      case "button_outline_inverted":
        return "outline-inverted";
      default:
        return "default";
    }
  }

  getBackgroundImage(teaser) {
    return this.getTranslatedImage(teaser["background"], this.lang, "full");
  }
}
